import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { MembershipService } from 'app/core/services/membership.service';
import { APPLICATION_ID } from 'app/models/constants';
import {  VerifyOTPModel } from 'app/models/login.model';
import { NexusFormResultModel } from 'app/models/nexus-form-result.model';
import { TokenModel } from 'app/models/token.model';
import { SecurityService } from 'app/services/security.service';
import { environment } from 'environments/environment';
import { Subscription, timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
@Component({
  standalone: false,
  selector: 'one-time-passcode',
  templateUrl: './one-time-passcode.component.html',
  styleUrls: ['./one-time-passcode.component.scss']
})
export class OneTimePasscodeComponent extends NexusComponent {


  otpForm: FormGroup;
  timerValue: number = 60;
  canResend: boolean = false;
  controls = Array.from({ length: 6 }, (_, i) => i);
  private timerSubscription!: Subscription;
  public form_result: NexusFormResultModel = new NexusFormResultModel();
  public verify_otp_model: VerifyOTPModel = new VerifyOTPModel();
  public otp_id: string;
  public token_model: TokenModel;
  public masked_user_otp_method: string;
  public otp_ttl_seconds: number =800;
  public otp_resend_ttl_seconds: number=60;
  public otp_info_model: TokenModel;
    public show_verify_otp: boolean =true;
  public another_mfa_method_type = null;
  public show_another_method: boolean = false;
  public show_customer_support: boolean = false;
  public another_method_form = new UntypedFormGroup({
    mfa_method:this.CreateFormControl('Email'),
  });
    faPhone =faPhone;
    faEnvelope =faEnvelope;
  constructor(private fb: FormBuilder,private membership_service: MembershipService,private router: Router,private activated_route: ActivatedRoute,private security_service: SecurityService) {
    super();
  }
  ngOnInit() {
    super.ngOnInit();
    this.activated_route.params.subscribe(params => {
      this.otp_id =params.otp_id;
      this.load_otp_details();
    });


    const controlsConfig: { [key: string]: any } = {};
        for (let i = 0; i < 6; i++) {
          controlsConfig[i] = ['', [Validators.required, Validators.pattern('\\d')]];
        }
        this.otpForm = this.fb.group(controlsConfig);




  }

  load_otp_details() {
    this.StartSpinner();
    this.security_service.GetOTPDetails(this.otp_id).subscribe({
      next:(data)=>{
        this.StopSpinner();
                this.otp_info_model = data;
        this.masked_user_otp_method= data.mfa_method == "SMS" ? data.masked_user_phone : data.masked_user_email;
        this.another_method_form.get('mfa_method').setValue(data.mfa_method);
        this.otp_resend_ttl_seconds =data.otp_resend_ttl_seconds;
        this.otp_ttl_seconds=data.otp_ttl_seconds;

        this.startTimer();
      },
      error:(err)=>{   this.StopSpinner();}
    })
  }
  clear_otp(){
    this.otpForm.reset();
  }

  resend_otp_details() {
    this.StartSpinner();
    this.startTimer();
   let resend_otp_model: VerifyOTPModel = new VerifyOTPModel();
   const otpCode = this.getOtpCode();
      const mfa_method = this.another_mfa_method_type;
   resend_otp_model ={
     otp_id : this.otp_id,
     client_id : environment.client_id,
     application_id : APPLICATION_ID,
          otp_code : otpCode,
     mfa_method : mfa_method
   };
    this.security_service.ResendOTP(resend_otp_model).subscribe({
      next:(data)=>{
        this.StopSpinner();
        this.clear_otp();
      },
      error:(err)=>{   this.StopSpinner();}
    })
  }

  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Only allow digits
    if (!/^\d$/.test(value)) {
      input.value = '';
      return;
    }

    // Move to next input if value is valid
    if (value && index < this.controls.length - 1) {
      const nextInput = document.querySelectorAll<HTMLInputElement>('.otp-input')[index + 1];
      nextInput?.focus();
    }
  }


  onKeyDown(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prev = input.previousElementSibling as HTMLInputElement;
      prev?.focus();
    }
  }

  onPaste(event: ClipboardEvent): void {
      event.preventDefault();
      const pastedData = event.clipboardData?.getData('text') || '';
      const digits = pastedData.replace(/\D/g, '').split('').slice(0, this.controls.length);

      digits.forEach((digit, index) => {
        const controlKey = this.controls[index].toString();
        this.otpForm.get(controlKey)?.setValue(digit);
      });
    }

    getOtpCode(): string {
      return this.controls
        .map(i => this.otpForm.get(i.toString())?.value || '')
        .join('');
    }


    verify_otp() {
    this.form_result.Reset();

    this.SetFormTouched(this.otpForm);
    if (this.otpForm.invalid) {
      this.form_result.Incomplete();
      return;
    }

    this.StartSpinner();
    const otpCode = this.getOtpCode();
    this.verify_otp_model ={
      otp_id : this.otp_id,
      client_id : environment.client_id,
      application_id : APPLICATION_ID,
      otp_code : otpCode,
      mfa_method : null
    };
    this.security_service.VerifyOTP(this.verify_otp_model).subscribe(
      data => {
          this.token_model = data;
          this.StopSpinner();

            if(data.token)
            {
              this.form_result.Success();
              this.membership_service.SetToken(data);
              this.security_service.SetDeviceToken(data.device_token)
              if (this.membership_service.redirectUrl) {
                var route =this.membership_service.redirectUrl;
                this.membership_service.redirectUrl=null;
                this.router.navigate([route]);
                return;
            }

              this.router.navigate(['/']);
            }

      },
      error => {
        this.form_result.Error(error);
        this.StopSpinner();
      });

  }


  startTimer(): void {

    this.timerSubscription?.unsubscribe(); // Prevent overlap
      this.canResend = false;
      const countdownStart = this.otp_resend_ttl_seconds;
      this.timerValue = countdownStart;

      this.timerSubscription = timer(0, 1000).pipe(
        map(i => countdownStart - i),
        takeWhile(val => val >= 0)
      ).subscribe(val => {
        this.timerValue = val;
        this.canResend = val === 0;
      });

    }
    resend_otp_another_method(){

          this.StartSpinner();
    this.startTimer();
   let resend_otp_model: VerifyOTPModel = new VerifyOTPModel();
   const otpCode = this.getOtpCode();
   const mfa_method =this.another_method_form.get('mfa_method').value;
   resend_otp_model ={
     otp_id : this.otp_id,
     client_id : environment.client_id,
     application_id : APPLICATION_ID,
     otp_code : otpCode,
     mfa_method : mfa_method
   };
    this.security_service.ResendOTP(resend_otp_model).subscribe({
      next:(data)=>{
        this.another_mfa_method_type = mfa_method;
         this.masked_user_otp_method= mfa_method == "SMS" ? this.otp_info_model.masked_user_phone : this.otp_info_model.masked_user_email;
        this.otp_another_method_cancel();
        this.StopSpinner();

      },
      error:(err)=>{   this.StopSpinner();}
    })

  }
  otp_another_method_cancel(){
    this.show_another_method=false;
    this.show_customer_support=false;
    this.show_verify_otp=true;
  }
  try_another_method(){
      if(this.otp_info_model?.masked_user_phone){
        this.show_another_method=true;
        this.show_customer_support=false;
        this.show_verify_otp=false;
      } else{
         this.show_another_method=false;
        this.show_customer_support=true;
        this.show_verify_otp=false;
      }

  }
  ngOnDestroy(): void {
    this.timerSubscription?.unsubscribe();
  }
}
